// Saving a customer's receipt details (company name, address, tax id).
//
// They used to travel in a GET query string, so they landed in request logs
// (Cloudflare, Cloud Run, the browser history). They now go in a POST body to
// the same path (S3, 6 October 2026; the contract agreed with the backend:
// the same three fields, as strings, as JSON).

export const RECEIPT_DETAILS_PATH = '/api/set_custom_receipt_details'

// The fields exactly as the GET sent them: URLSearchParams turns every value
// into a string, so the body carries the same strings the query did.
export const receiptDetailsFields = (details) =>
  Object.fromEntries(new URLSearchParams(details))

export async function saveReceiptDetails({
  baseUrl,
  idToken,
  details,
  fetchImpl = fetch,
}) {
  const fields = receiptDetailsFields(details)
  const headers = {
    Authorization: idToken,
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }
  const response = await fetchImpl(`${baseUrl}${RECEIPT_DETAILS_PATH}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(fields),
  })
  // A backend without the POST answers 405. Remove this fallback once the
  // backend's POST is live (backend step S3), so the details never go in a URL.
  if (response.status !== 405) return response
  return fetchImpl(
    `${baseUrl}${RECEIPT_DETAILS_PATH}?${new URLSearchParams(fields)}`,
    { method: 'GET', headers },
  )
}
